<template>
  <div class="accountInfo" v-if="isLogin">
    <div class="accountInfoChange" :class="{ changeError: status == false }">
      <div class="changeLabel">
        <el-popover
          placement="top-start"
          title="账号生成规则："
          width="200"
          trigger="hover"
          content="命名规则采用机构拼音首字母大写+姓名全拼组合方式，同一机构中若有重名的，在用户名后加002、003，以此类推。"
        >
          <i slot="reference" class="el-icon-question" color="#3C8DDB"></i>
        </el-popover>
        账号：
      </div>
      <el-input
        placeholder="请输入账号"
        v-model="accountName"
        style="width: 400px;"
        :disabled="!edit"
        :maxlength="20"
        v-loading="loading"
      >
        <!-- <i
          slot="suffix"
          class="el-input__icon el-icon-edit changeEdit"
          color="#3C8DDB"
          v-if="!edit"
          @click="edit = true"
        ></i> -->
        <span
          slot="suffix"
          class="el-input__icon changeSubmit"
          v-if="edit"
          @click="submit"
        >
          确定
        </span>
      </el-input>
      <div class="changeInfo">
        <div class="infoSuccess" v-if="status">
          <i class="el-icon-success"></i>{{ message }}
        </div>
        <div class="infoError" v-if="status == false">
          <i class="el-icon-error"></i>{{ message }}
        </div>
      </div>
    </div>
    <!-- <div class="info">注：账号可自行修改，建议修改后的账号前缀加上各省简称</div> -->
    <div class="tableTitle">省级简称国际参照表</div>
    <el-scrollbar class="customTable">
      <table cellSpacing="0" cellPadding="0">
        <thead>
          <tr>
            <template v-for="(item, index) in 2">
              <th :key="index">序号</th>
              <th width="215" :key="index">省份</th>
              <th :key="index">区划代码</th>
              <th :key="index">简称</th>
            </template>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(item, index) in spliceList" :key="index">
            <template v-for="(item2, index) in 2">
              <td :key="index">{{ item[index].index }}</td>
              <td :key="index">{{ item[index].name }}</td>
              <td :key="index">{{ item[index].code }}</td>
              <td :key="index">{{ item[index].alias }}</td>
            </template>
          </tr>
        </tbody>
      </table>
    </el-scrollbar>
  </div>
</template>

<script>
export default {
  name: "DsfAccountInfo",
  data() {
    return {
      loading: true,
      accountName: null,
      edit: false, // true 编辑 false 禁止编辑
      status: null, // true 成功 false 错误
      message: null,
      list: [
        {
          name: "北京市",
          code: "110000",
          alias: "BJ",
        },
        {
          name: "天津市",
          code: "120000",
          alias: "TJ",
        },
        {
          name: "河北省",
          code: "130000",
          alias: "HE",
        },
        {
          name: "山西省",
          code: "140000",
          alias: "SX",
        },
        {
          name: "内蒙古自治区",
          code: "150000",
          alias: "NM",
        },
        {
          name: "辽宁省",
          code: "210000",
          alias: "LN",
        },
        {
          name: "吉林省",
          code: "220000",
          alias: "JL",
        },
        {
          name: "黑龙江省",
          code: "230000",
          alias: "HL",
        },
        {
          name: "上海市",
          code: "310000",
          alias: "SH",
        },
        {
          name: "江苏省",
          code: "320000",
          alias: "JS",
        },
        {
          name: "浙江省",
          code: "330000",
          alias: "ZJ",
        },
        {
          name: "安徽省",
          code: "340000",
          alias: "AH",
        },
        {
          name: "福建省",
          code: "350000",
          alias: "FJ",
        },
        {
          name: "江西省",
          code: "360000",
          alias: "JX",
        },
        {
          name: "山东省",
          code: "370000",
          alias: "SD",
        },
        {
          name: "河南省",
          code: "410000",
          alias: "HA",
        },
        {
          name: "湖北省",
          code: "420000",
          alias: "HB",
        },
        {
          name: "湖南省",
          code: "430000",
          alias: "HN",
        },
        {
          name: "广东省",
          code: "440000",
          alias: "GD",
        },
        {
          name: "广西壮族自治区",
          code: "450000",
          alias: "GX",
        },
        {
          name: "海南省",
          code: "460000",
          alias: "HI",
        },
        {
          name: "四川省",
          code: "510000",
          alias: "SC",
        },
        {
          name: "贵州省",
          code: "520000",
          alias: "GZ",
        },
        {
          name: "云南省",
          code: "530000",
          alias: "YN",
        },
        {
          name: "西藏自治区",
          code: "540000",
          alias: "XZ",
        },
        {
          name: "重庆市",
          code: "500000",
          alias: "CQ",
        },
        {
          name: "陕西省",
          code: "610000",
          alias: "SN",
        },
        {
          name: "甘肃省",
          code: "620000",
          alias: "GS",
        },
        {
          name: "青海省",
          code: "630000",
          alias: "QH",
        },
        {
          name: "宁夏回族自治区",
          code: "640000",
          alias: "NX",
        },
        {
          name: "新疆维吾尔族自治区",
          code: "650000",
          alias: "XJ",
        },
        {
          name: "新疆生产建设兵团",
          code: "690000",
          alias: "BT",
        },
      ],
      isLogin: false,
    };
  },
  created() {
    this.isLogin = !!dsf.getToken();
    if (this.isLogin) {
      dsf.http.get("tjyUser/getUserAccount").then((res) => {
        if (res.data.success) {
          this.accountName = res.data.data;
          this.loading = false;
        }
      });
    } else {
      dsf.layer.alert("请重新登录", "提示", false).finally(() => {
        let loginUrl = dsf.config.setting_public_pc_login_page;
        location.replace(loginUrl);
      });
    }
  },
  computed: {
    spliceList() {
      const b = JSON.parse(JSON.stringify(this.list)).map((item, index) => {
        item.index = index + 1;
        return item;
      });
      const a = b.splice(0, Math.ceil(b.length / 2));
      return a.map((item, index) => {
        const result = [item];
        if (b[index]) result.push(b[index]);
        return result;
      });
    },
  },
  methods: {
    submit() {
      if (!this.accountName.length) {
        this.status = false;
        this.message = "请输入用户名";
        return false;
      }
      this.loading = true;
      dsf.http
        .post("tjyUser/updateAccount?account=" + this.accountName)
        .then((res) => {
          const { success, message } = res.data;
          this.status = success;
          if (success) {
            this.edit = false;
          }
          this.message = message;
          this.loading = false;
        });
    },
  },
};
</script>
